/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Taxonomy_Use_Cases_Coding_TitleInputs */

const en_directory_taxonomy_use_cases_coding_title = /** @type {(inputs: Directory_Taxonomy_Use_Cases_Coding_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build software`)
};

const zh_directory_taxonomy_use_cases_coding_title = /** @type {(inputs: Directory_Taxonomy_Use_Cases_Coding_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`构建软件`)
};

/**
* | output |
* | --- |
* | "Build software" |
*
* @param {Directory_Taxonomy_Use_Cases_Coding_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_taxonomy_use_cases_coding_title = /** @type {((inputs?: Directory_Taxonomy_Use_Cases_Coding_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Taxonomy_Use_Cases_Coding_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_taxonomy_use_cases_coding_title(inputs)
	return zh_directory_taxonomy_use_cases_coding_title(inputs)
});
export { directory_taxonomy_use_cases_coding_title as "directory.taxonomy.use-cases.coding.title" }